import styled from 'styled-components';
import homeFeaturesBg from '../../../assets/backgrounds/home_features_background.svg';

export const GradientSection = styled.section`
  padding-top: 120px;
  background-image: url(${homeFeaturesBg});
  background-repeat: no-repeat;
  background-size: 100%;
}
`;
